import PubNub from 'pubnub';

import getUserChatToken from './getUserChatToken';

const subscribeKey = window.BENCH ? window.BENCH.vendor.pubnub.subscribe_key : '';
const ssl = window.location.protocol === 'https:';

/**
 * @typedef {Object} PubNubInstance
 * @property {Object} client - The PubNub client itself
 * @property {Array.<Subscription>} subscriptions - Stored subscriptions
 * @property {Function} getSubscriptionId - Returns an integer
 *
 * Creates a PubNubInstance with a contained scope for setting the singleton
 * variable and maintaining an incrementing count of subscription IDs.
 * @return {Promise.<PubNubInstance>}
 */
export const createPubNubInstance = async () => {
  // the clientId in response is actually a personId value, perfect for uuid
  const { chatToken: authKey, clientId: uuid } = await getUserChatToken();
  let nextId = 1;
  return {
    client: new PubNub({ subscribeKey, ssl, authKey, uuid }),
    subscriptions: [],
    getSubscriptionId() {
      return nextId++;
    },
  };
};

/**
 * Retrieves a PubNub instance while deferring requests if multiple consumers
 * try to get an instance before one is set.
 * @returns {Promise.<PubNubInstance>}
 */
let pubNubPromise;
const getPubNubInstance = () => {
  if (pubNubPromise) return pubNubPromise;
  pubNubPromise = createPubNubInstance();
  return pubNubPromise;
};

export default getPubNubInstance;
